// src/utils/setupEmployees.js
// Run this script once to create demo employee accounts in Firebase

import { auth, db } from '../firebase';
import { createUserWithEmailAndPassword, signOut } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { tryResolveTenantId } from '../utils/tenant';

const setupEmployees = async () => {
  const employees = [
    {
      email: 'john.doe@restaurant.com',
      password: 'demo123',
      firstName: 'John',
      lastName: 'Doe',
      employeeId: 'EMP001',
      department: 'Kitchen',
      role: 'Line Cook',
      phone: '(555) 123-4567',
      address: '123 Main St, City, State 12345',
      hireDate: '2024-03-15',
      employmentType: 'Full-time',
      status: 'Active',
      overtimeEligible: true,
      hourlyRate: 18.50
    },
    {
      email: 'jane.smith@restaurant.com',
      password: 'demo123',
      firstName: 'Jane',
      lastName: 'Smith',
      employeeId: 'EMP002',
      department: 'Front of House',
      role: 'Server',
      phone: '(555) 234-5678',
      address: '456 Oak Ave, City, State 12345',
      hireDate: '2024-01-20',
      employmentType: 'Part-time',
      status: 'Active',
      overtimeEligible: false,
      hourlyRate: 15.00
    }
  ];

  console.log('Setting up demo employee accounts...');

  for (const employee of employees) {
    try {

      
      // Create Firebase Auth user
      const userCredential = await createUserWithEmailAndPassword(
        auth, 
        employee.email, 
        employee.password
      );
      
      const user = userCredential.user;

      
      // Create employee document in Firestore
      const employeeData = {
        ...employee,
        uid: user.uid
      };
      delete employeeData.password; // Don't store password in Firestore
      
  const tenantId = await tryResolveTenantId();
  if (!tenantId) throw new Error('tenantId not resolved');
  await setDoc(doc(db, `tenants/${tenantId}/employees`, user.uid), employeeData);

      
      // Sign out the user so we can create the next one
      await signOut(auth);
      

      
    } catch (error) {
      if (error.code === 'auth/email-already-in-use') {

      } else {
        console.error(`❌ Error creating ${employee.email}:`, error.message);
      }
    }
  }
  
  console.log('🎉 Demo employee setup complete!');
  console.log('\nYou can now log in with:');
  console.log('Email: john.doe@restaurant.com');
  console.log('Password: demo123');
  console.log('\nOr:');
  console.log('Email: jane.smith@restaurant.com');
  console.log('Password: demo123');
};

export default setupEmployees;
